import { FC } from "react";
import { Typography, TypographyT } from "@rmwc/typography";
import "@material/typography/dist/mdc.typography.css";
import useConfigs from "../../ConfigContext/use-configs";
import { ThemeType } from "../../../commons/theme";
import useTheme from "../../../commons/hooks/use-theme";

export type TextProps = {
  type?: "head1" | "head2" | "head3" | "subtitle" | "textHint" | "paragraph" | "subtitle2";
  dir?: string;
  tag?: "h1" | "h2" | "h3" | "p" | "span" | "div";
  error?: boolean;
  className?: string;
  id?: string;
  role?: string;
  hidden?: boolean;
  themeType?: ThemeType;
};

const Text: FC<TextProps> = (props) => {
  const theme = useTheme();
  let configs = useConfigs();

  const { children, type, dir = configs.direction, tag, error = false, className, themeType } = props;
  let selectedTheme = themeType && themeType !== theme.type ? theme.secondaryTheme : theme;

  let textColor;
  if (error) {
    textColor = selectedTheme.material.error;
  } else {
    textColor = selectedTheme.material.textPrimaryOnBackground;
  }

  let use: TypographyT = "body1";

  switch (type) {
    case "head1":
      use = "headline2";
      break;
    case "head2":
      use = "headline4";
      break;
    case "head3":
      use = "headline6";
      break;
    case "subtitle2":
      use = "subtitle2";
      break;
    case "subtitle":
      use = "subtitle1";
      break;
    case "textHint":
      use = "caption";
      break;
    case "paragraph":
      use = "body1";
      break;
  }

  return (
    <Typography
      style={{ color: textColor }}
      use={use}
      dir={dir.valueOf()}
      tag={tag}
      className={`muis--typography ${className}`}
    >
      {children}
    </Typography>
  );
};

export default Text;
